<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <template-listing-item-base v-bind:id="template.Id"
                                v-bind:name="template.Name"
                                v-bind:date="template.PublishDate"
                                v-bind:can-delete="canDelete"
                                v-bind:can-edit="canEdit"
                                @template-deleted="$emit('template-deleted', $event)"
                                @template-selected="$emit('template-selected', $event)"
    >
        <template v-slot:sub-text-label="{ formattedDate }">
            <template v-if="template.IsPublished">
                {{ resource('TemplateRegularListingItem_Item_SubTextLabel_Published') }} {{ formattedDate }}
            </template>
            <template v-else>
                {{ resource('TemplateRegularListingItem_Item_SubTextLabel_NotPublished') }}
            </template>
        </template>

        <template v-slot:additional-controls>
            <i
                    v-if="canPublish"
                    v-bind:class="{'published': template.IsPublished}"
                    class="fas fa-file-upload mdb-icon-btn new fa-lg mr-1 btn-publish"
                    aria-hidden="true"
                    @click.stop="promptPublish"
            ></i>
        </template>
    </template-listing-item-base>
</template>

<script>
    import moment from 'moment';
    
    import templateManagerApi from '../../../../Api/template-manager';
    import securityApi from '../../../../Util/security';

    import growlApi from '../../../../Util/growler';
    import { promptV2 } from '../../../../Util/prompt';
    import resourceMixin from '../../../../Util/Mixins/resources';
    import TemplateListingItemBase from './TemplateListingItemBase.vue';

    export default {
        name: "template-regular-listing-item",
        components: {
            TemplateListingItemBase
        },
        mixins: [resourceMixin],
        beforeCreate(){
            const vm = this;

            templateManagerApi.validateFillerPermission(securityApi.PermissionGrantTypes.Write).then(
                canWrite => vm.canEdit = canWrite
            );

            templateManagerApi.validateFillerPermission(securityApi.PermissionGrantTypes.Delete).then(
                canDelete => vm.canDelete = canDelete
            );
        },
        methods: {
            promptPublish(){
                const vm = this;
                
                const body = vm.template.IsPublished ?
                    vm.resource('TemplateRegularListingItem_PublishRecordPrompt_AlreadyPublished_Body') :
                    vm.resource('TemplateRegularListingItem_PublishRecordPrompt_Body');
                
                promptV2(
                    vm.resource('TemplateRegularListingItem_PublishRecordPrompt_Title'),
                    body
                ).then(
                    () => {
                        templateManagerApi.publishTemplate(vm.template.Id).then(
                            () => {
                                vm.template.PublishDate = moment().toDate();
                                vm.template.IsPublished = true;
                                vm.$emit('template-published');
                            },
                            err => growlApi.error(err)
                        );
                    },
                    () => { /*Do nothing */ }
                );
            }
        },
        data(){
            return {
                canDelete: false,
                canEdit: false,
                canPublish: true
            }
        },
        props: {
            template: {
                type: Object,
                required: true,
                default() {
                    return {
                        Id: '',
                        Name: '',

                        IsPublished: false,
                        PublishDate: new Date()
                    }
                }
            }
        }
    };
</script>

<style scoped lang="scss" src="../../Style/template-publishable-listing-item.scss"></style>
